/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Binding_R2_DetailInputs */

const en_marketing_binding_r2_detail = /** @type {(inputs: Marketing_Binding_R2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File storage for uploads, served straight from the Worker.`)
};

const es_marketing_binding_r2_detail = /** @type {(inputs: Marketing_Binding_R2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almacenamiento de archivos para subidas, servido directamente desde el Worker.`)
};

const fr_marketing_binding_r2_detail = /** @type {(inputs: Marketing_Binding_R2_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stockage de fichiers pour les envois, servi directement depuis le Worker.`)
};

/**
* | output |
* | --- |
* | "File storage for uploads, served straight from the Worker." |
*
* @param {Marketing_Binding_R2_DetailInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_binding_r2_detail = /** @type {((inputs?: Marketing_Binding_R2_DetailInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Binding_R2_DetailInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_binding_r2_detail(inputs)
	if (locale === "es") return es_marketing_binding_r2_detail(inputs)
	return fr_marketing_binding_r2_detail(inputs)
});